import { Link } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { Button } from '#app/ui/components/buttons/button.tsx'
import { Section } from '#app/ui/components/custom/section'
import { H2 } from '#app/ui/components/typography/h2'
import { Lead } from '#app/ui/components/typography/lead'
import { cn } from '#app/utils/tailwind-merge.js'

export const CTA = ({ className }: { className?: string }) => {
	const { t } = useTranslation('home')

	return (
		<Section tone="panel" className={cn(className)}>
			<div className="mx-auto flex max-w-2xl flex-col items-center text-center">
				<H2 className="text-balance normal-case">{t('cta.heading')}</H2>
				<Lead className="mt-fluid-9 text-muted-600">{t('cta.lead')}</Lead>
				<Button asChild size="lg" className="mt-fluid-16 px-12">
					<Link to="/call">{t('cta.button')}</Link>
				</Button>
			</div>
		</Section>
	)
}
